import React from 'react';
import ReactDataTable from 'react-data-table-component';
import { StyleSheetManager } from 'styled-components';

const internalOnlyProps = new Set(['right', 'allowOverflow', 'button', 'minWidth']);

const paginationComponentOptions = {
  rowsPerPageText: 'Linhas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todas'
};

const defaultProgressComponent = (
  <div className="d-flex align-items-center gap-2 py-4 text-muted">
    <span className="spinner-border spinner-border-sm" aria-hidden="true" />
    <span>Carregando...</span>
  </div>
);

const defaultNoDataComponent = (
  <div className="py-4 text-muted">Não há registros para exibir.</div>
);

export default function DataTablePtBr({
  paginationComponentOptions: customPaginationOptions,
  progressComponent,
  noDataComponent,
  ...props
}) {
  return (
    <StyleSheetManager shouldForwardProp={(prop) => !internalOnlyProps.has(prop)}>
      <ReactDataTable
        {...props}
        paginationComponentOptions={{
          ...paginationComponentOptions,
          ...customPaginationOptions
        }}
        progressComponent={progressComponent || defaultProgressComponent}
        noDataComponent={noDataComponent || defaultNoDataComponent}
      />
    </StyleSheetManager>
  );
}
